<!--
File: cc-cell-item.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Tuesday, 17th February 2026 5:36:32 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->
<div
  (click)="sendItemToDetailContainer()"
  (dblclick)="showProductDetails()"
  (contextmenu)="onRightClick($event, menuCell)"
  pDraggable
  (onDragStart)="onDrag()"
  (onDragEnd)="onDragEnd()"
  class="cc-cell-item"
  [ngClass]="!locked ? 'disabled' : ''"
>
  <div
    [lazyBg]="item.img"
    class="cc-cell-item__image"
  >
    <div
      class="flex flex-row justify-content-between cell-toolbar mt-0 align-content-center align-self-start cc-cell-item__toolbar-inner"
    >
      <p-tieredMenu
        [model]="cellMenu"
        [styleClass]="'cell-menu'"
        #menuCell
        [popup]="true"
        [appendTo]="'body'"
      ></p-tieredMenu>

    </div>
  </div>

  <!-- Drag viewer container  -->
  <div class="item-drag-product">
    <img
      [src]="item.img == null ? './assets/img/nube_cc_200x140.png' : item.img"
    />
  </div>

  <div
    style="
      margin-left: 0;
      margin-top: 50%;
      border: 1px solid var(--surface-border);
      max-width: auto;
      padding: 0.5em 0.5em;
      position: absolute;
      z-index: 999;
      background-color: var(--yellow-200);
      border-left: 0px;
    "
    class=" border-round-right shadow-4 hover:bg-blue-600 cursor-pointer"
    pTooltip="{{ pageCell.notes }}"
    (click)="editNotes()"
    *ngIf="pageCell.notes"
  >
    <!-- <i class="fa fa-sticky-note text-yellow-200" *ngIf="pageCell.notes"></i> -->
  </div>

  <div
    class="text-xs align-self-end max-w-full min-w-full shadow-1 border-0 cell-info-bar"
  >
    <div
      class="cell-current-model"
      *ngIf="currentModel && currentModel != 'Base'"
    >
      <div class="cell-current-model-data">
        <i class="fa fa-star"></i> <span>{{ currentModel }}</span>
      </div>
    </div>
    <div class="pl-2 pr-2 pb-1 overflow-hidden max-w-full">
      <div
        class="overflow-hidden white-space-nowrap text-overflow-ellipsis font-bold"
      >
        <span>{{ currentVariant ? currentVariant.name : item.name }}</span>
      </div>
      <div>
        <span class="product-sku"
          >Sku: {{ currentVariant ? currentVariant.sku : item.sku }}</span
        >
      </div>
    </div>
  </div>
</div>